export function StatusBadge({ status }: { status: string }) {
    const colorMap: Record<string, string> = {
        ACTIVE: 'bg-green-100 text-green-800',
        SUSPENDED: 'bg-yellow-100 text-yellow-800',
        DELETED: 'bg-red-100 text-red-800',
    };

    return (
        <span
            className={`px-2 py-1 rounded text-xs font-medium ${colorMap[status] || 'bg-gray-100 text-gray-800'}`}
        >
            {status}
        </span>
    );
}
